import React from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import * as Middleware from "@middlewares/index";

export const NetworkingComplete = () => {
  const history = useHistory();
  const location = useLocation();

  const onClose = () => {
    history.replace({
      pathname: location.pathname,
      state: undefined,
    });
    Middleware.Ui.Modal.close();
  };

  return (
    <div className="modal-wrap">
      <div className="modal modal--content !p-[64px] !gap-0 !rounded-xl">
        <div className="modal__header mb-[32px]">
          <button className="modal__close" onClick={() => onClose()} />
          <h1 className="text-[3rem] !m-0 font-bold">
            Теперь вы в Нетворкинге!
          </h1>
        </div>
        <div className="flex justify-between !m-0">
          <div className="flex flex-col gap-5 !m-0">
            <div className="flex flex-col gap-2 !m-0">
              <p className="!m-0 text-lg">У Вас есть визитка</p>
              <p className="!m-0 text-[#888899]">
                Система сформировала вашу онлайн-визитку. Теперь вы можете
                обмениваться визитками, чтобы найти партнёров в турбизнесе.
              </p>
            </div>

            <div className="flex gap-3">
              <div>
                <svg
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.7071 4.79289C16.0976 5.18342 16.0976 5.81658 15.7071 6.20711L7.70711 14.2071C7.31658 14.5976 6.68342 14.5976 6.29289 14.2071L2.29289 10.2071C1.90237 9.81658 1.90237 9.18342 2.29289 8.79289C2.68342 8.40237 3.31658 8.40237 3.70711 8.79289L7 12.0858L14.2929 4.79289C14.6834 4.40237 15.3166 4.40237 15.7071 4.79289Z"
                    fill="#185ADB"
                  />
                </svg>
              </div>
              <div className="flex flex-col gap-2 !m-0">
                <p className="!m-0 text-lg">
                  Добавьте фото, чтобы вас заметили
                </p>
                <p className="!m-0 text-[#888899]">
                  Визитки с фотографиями автоматически попадают в верхние
                  строчки каталога
                </p>
              </div>
            </div>

            <div className="flex gap-3">
              <div>
                <svg
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.7071 4.79289C16.0976 5.18342 16.0976 5.81658 15.7071 6.20711L7.70711 14.2071C7.31658 14.5976 6.68342 14.5976 6.29289 14.2071L2.29289 10.2071C1.90237 9.81658 1.90237 9.18342 2.29289 8.79289C2.68342 8.40237 3.31658 8.40237 3.70711 8.79289L7 12.0858L14.2929 4.79289C14.6834 4.40237 15.3166 4.40237 15.7071 4.79289Z"
                    fill="#185ADB"
                  />
                </svg>
              </div>
              <div className="flex flex-col gap-2 !m-0">
                <p className="!m-0 text-lg">
                  Узнавайте как можно больше о партнерах{" "}
                </p>
                <p className="!m-0 text-[#888899]">
                  В разделе Нетворкинга просматривайте карточки партнеров.
                  Внутри каждой карточки человека или компании можно узнать
                  больше о деятельности и направлениях, с которыми они
                  работают. 
                </p>
              </div>
            </div>
          </div>
          <img
            className="hidden self-start md:flex min-w-[301px]"
            src={require("@public/images/computer.svg")}
            alt="Компьютер"
          />
        </div>
        <Link
          to="/networking"
          className="btn btn--weight-700 btn--medium btn--blue mt-[40px]"
          onClick={() => Middleware.Ui.Modal.close()}
        >
          Перейти в Нетворкинг
        </Link>
      </div>
    </div>
  );
};
